import { FC } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import tw from 'twin.macro'
import { ImageField } from '@prismicio/client'
import { Body, Grid, Header, SmallBody, SubHeader } from '../UI'

type Props = {
  header: string
  subhead: string
  percentage_1: number
  copy_1: string
  percentage_2: number
  copy_2: string
  image: ImageField
  citation: string
}

const PuttingPrevention: FC<Props> = ({
  header,
  subhead,
  percentage_1,
  copy_1,
  percentage_2,
  copy_2,
  image,
  citation,
}) => {
  return (
    <section tw="bg-gb-magenta pb-[68px] lg:(pt-[72px] pb-[55px]) text-white font-domaine overflow-x-hidden">
      <Grid tw="mx-0">
        {/* Headline content */}
        <div tw="order-2 col-span-full mx-[30px] pt-[62px] lg:(order-1 col-span-6 mx-0 pt-0)">
          <h2 css={[Body, tw`mb-[10px] lg:mb-[25px]`]}>{header}</h2>
          <h3 css={[Header, tw`pr-6 mb-[72px] lg:pr-0`]}>{subhead}</h3>
          <h4 tw="font-object w-[90%] lg:w-[50%] mb-[58px]">
            <span tw="text-[56px] line-height[1]">{percentage_1}</span>
            <span tw="text-[28px] line-height[1]">%</span>
            <span css={[SubHeader, tw`font-domaine block mt-2`]}>{copy_1}</span>
          </h4>
          <h4 tw="font-object w-[90%] lg:w-[65%]">
            <span tw="text-[56px] line-height[1]">{percentage_2}</span>
            <span tw="text-[28px] line-height[1]">%</span>
            <span css={[SubHeader, tw`font-domaine block mt-2`]}>{copy_2}</span>
          </h4>
          <div css={[SmallBody, tw`col-span-full mt-12`]}>{citation}</div>
        </div>
        <div tw="order-1 col-span-full lg:(order-2 col-start-7 col-span-6 relative)">
          <GatsbyImage
            image={getImage(image)}
            tw="w-full h-[411px] object-cover object-position[50% 50%] lg:(absolute object-position[100% 0%] top-[-72px] h-[calc(100% + 72px + 55px)] left-0 w-[calc(100% + (100vw - 1024px) / 2)] max-w-none mb-0) xl:(w-[calc(100% + (100vw - 1280px) / 2)])"
            alt=""
            objectFit="cover"
            objectPosition="100% 0%"
          />
        </div>
      </Grid>
    </section>
  )
}

export default PuttingPrevention
